import { Outlet } from "react-router-dom";
import ResponsiveDrawer from "@/components/layout/ResponsiveDrawer";

export default function AppLayout() {
  return (
    <ResponsiveDrawer>
      <Outlet />
    </ResponsiveDrawer>
  );
}
